import { updateSearchParams } from '#pplx/frontend/apps/ask/routing/historySearchParams.js';
import { ASK_INPUT_MENU } from '#pplx/frontend/apps/ask/types/askInputMenu.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
import { useEffect } from 'react';
export function useAskInputModelCouncilUrlIntent(searchModeControllerProps) {
    const searchParams = useSearchParams();
    useEffect(() => {
        // Read the live URL so another effect or a remount cannot replay a consumed intent.
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('open_model_council') && searchModeControllerProps.showSearchMode) {
            updateSearchParams({ open_model_council: undefined });
            searchModeControllerProps.onSearchModeSelect(SearchMode.AGENTIC_RESEARCH);
        }
    }, [searchParams, searchModeControllerProps]);
}
export function useAskInputWindowsVoiceUrlIntents({ isWindowsApp, onStartDictation, onOpenVoiceToVoice, }) {
    const searchParams = useSearchParams();
    useEffect(() => {
        if (!isWindowsApp)
            return;
        const urlParams = new URLSearchParams(window.location.search);
        // Keep the legacy order when both voice options are present.
        if (urlParams.get('voice-mode')) {
            updateSearchParams({ 'voice-mode': undefined });
            onStartDictation?.();
        }
        else if (urlParams.get('v2v')) {
            updateSearchParams({ v2v: undefined });
            onOpenVoiceToVoice();
        }
    }, [searchParams, isWindowsApp, onStartDictation, onOpenVoiceToVoice]);
}
export function useAskInputModelSelectorUrlIntent(onActiveMenuChange) {
    const searchParams = useSearchParams();
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('open_model_selector')) {
            updateSearchParams({ open_model_selector: undefined });
            // URL entry has never sent the normal model-menu opening analytics event.
            onActiveMenuChange(ASK_INPUT_MENU.SEARCH_MODEL_MENU);
        }
    }, [searchParams, onActiveMenuChange]);
}
//# sourceMappingURL=useAskInputUrlIntents.js.map